"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableRows = void 0;
var React = __importStar(require("react"));
var __1 = require("../");
var _1 = require("./");
var SharedComponents_1 = require("./SharedComponents");
var EditableRows = /** @class */ (function (_super) {
    __extends(EditableRows, _super);
    function EditableRows(props) {
        return _super.call(this, props) || this;
    }
    EditableRows.prototype.shouldComponentUpdate = function (nextProps) {
        return (nextProps.editMode !== this.props.editMode ||
            nextProps.deletedUniqueIds !== this.props.deletedUniqueIds ||
            nextProps.duplicatedExistingUniqueIds !== this.props.duplicatedExistingUniqueIds ||
            nextProps.data !== this.props.data);
    };
    EditableRows.prototype.render = function () {
        var _a = this.props, columns = _a.columns, data = _a.data, deleteColumn = _a.deleteColumn, deletedUniqueIds = _a.deletedUniqueIds, duplicateFields = _a.duplicateFields, duplicatedExistingUniqueIds = _a.duplicatedExistingUniqueIds, editMode = _a.editMode, enableHtmlEditor = _a.enableHtmlEditor, existingEditable = _a.existingEditable, isNewRow = _a.isNewRow, requireFields = _a.requireFields, typeAheadOptions = _a.typeAheadOptions, typeAheadDisplayRenderer = _a.typeAheadDisplayRenderer, getError = _a.getError, onChange = _a.onChange, onDelete = _a.onDelete, onFormatText = _a.onFormatText, onPaste = _a.onPaste, onSelect = _a.onSelect, onUpdate = _a.onUpdate, onValidate = _a.onValidate, deleteIconClick = _a.deleteIconClick, htmlEditorMode = _a.htmlEditorMode, toolbarConfiguration = _a.toolbarConfiguration;
        return (React.createElement(React.Fragment, null, data &&
            data.map(function (record, index) {
                var className = record.isNew ? '' : 'tws-editable-row-existing';
                if (duplicatedExistingUniqueIds.indexOf(record.uniqueId) > -1) {
                    className += ' duplicated';
                }
                var deleted = deletedUniqueIds.indexOf(record.uniqueId) > -1;
                var duplicated = duplicatedExistingUniqueIds.indexOf(record.uniqueId) > -1;
                return (React.createElement(_1.EditableRow, { className: className, key: "editable-row-".concat(isNewRow ? 'new-' : '').concat(index), record: record, editMode: editMode, enableHtmlEditor: enableHtmlEditor, htmlEditorMode: htmlEditorMode, toolbarConfiguration: toolbarConfiguration, deleted: deleted, duplicated: duplicated, requireFields: requireFields, duplicateFieldKeys: duplicateFields, onChange: onChange, onValidate: onValidate, onPaste: function (column, clipboardData, event) { return onPaste(index, column, clipboardData, event); }, onSelect: function (columnKey, option, event) { return onSelect(columnKey, option, false, event); }, onUpdate: onUpdate, onDelete: onDelete },
                    columns.map(function (column, columnIndex) {
                        var errorInfo = getError !== undefined ? getError(column, record) : { hasError: false };
                        return column.editable ? (React.createElement(_1.EditableColumn, __assign({ key: "editable-column-".concat(isNewRow ? 'new-' : '').concat(index, "-").concat(columnIndex), column: column, editMode: editMode, enableHtmlEditor: enableHtmlEditor, htmlEditorMode: htmlEditorMode, toolbarConfiguration: toolbarConfiguration, existingEditable: existingEditable, record: record, typeAheadOptions: typeAheadOptions, typeAheadDisplayRenderer: typeAheadDisplayRenderer, placeholder: column.placeholder }, errorInfo))) : (React.createElement(SharedComponents_1.TableColumn, { key: "editable-column-".concat(isNewRow ? 'new-' : '').concat(index, "-").concat(columnIndex), editMode: editMode }, onFormatText(column, record)));
                    }),
                    deleteColumn && (React.createElement(SharedComponents_1.TableColumn, { editMode: editMode },
                        React.createElement(SharedComponents_1.DeleteIconContainer, { editMode: editMode, deleted: deleted, onClick: function () { return deleteIconClick(record, deleted); } }, editMode && deleted ? React.createElement(SharedComponents_1.UndoIcon, { name: 'undo' }) : React.createElement(__1.Icon, { name: 'delete' }))))));
            })));
    };
    // Default props
    EditableRows.defaultProps = {
        enableHtmlEditor: false,
        duplicatedExistingUniqueIds: [],
        deletedUniqueIds: [],
        getError: function () { return ({}); },
        onPaste: function () {
            return;
        },
        onSelect: function () {
            return;
        },
    };
    return EditableRows;
}(React.Component));
exports.EditableRows = EditableRows;
